<template>
  <v-container class="mt-2 mb-10">
    <div class="admin-title">
      <div class="text-center">
        <h1>Admin</h1>
      </div>  
    </div>
    <div class="admin-info">
      <div class="text-justify">
        <p>Bienvenido a la sección de administración del sitio <strong>Tutoriales PATH</strong>. Donde podrás gestionar todo el contendio del sitio de una forma sencilla y eficaz.</p>
      </div>  
    </div>
    <div class="admin-table">
      <div class="text-right">
        <v-btn color="blue-grey darken-2" class="white--text" x-small @click="openAddSlide()">
          Agregar
        </v-btn>
      </div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">
                Relevancia
              </th>
              <th class="text-center">
                Imagen
              </th>
              <th class="text-center">
                Título
              </th>
              <th class="text-center">
                Video
              </th>
              <th class="text-center">
                Estatus
              </th>
              <th class="text-center">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(sl, index) in slides"
              :key="'slide_'+index"
            >
              <td class="text-center">
                {{ sl.relevancia }}
              </td>
              <td class="text-center">
                <v-img 
                  class="img-slide"
                  :src="sl.url_img"
                  max-height=80
                  max-width=150
                ></v-img>
              </td>
              <td class="text-center">
                {{ sl.titulo }}
              </td>
              <td class="text-center">
                <span v-if="sl.url_video!=='NA'">
                  <a :href="sl.url_video" class="video-slide">
                    <v-icon id="video-slide-icon">mdi mdi-file-video</v-icon>
                  </a>
                </span>
                <span v-else class="video-slide-na">
                  <strong>NA</strong>
                </span>
              </td>
              <td class="text-center">
                <span v-if="sl.estado_id" class="ss-activo">
                  Activo
                </span>
                <span v-else class="ss-inactivo">
                  Inactivo
                </span>
              </td>
              <td class="text-center">
                <div>
                  <v-btn color="blue darken-4" class="white--text" x-small @click="openEditSlide(index)">
                    Editar
                  </v-btn>
                </div>
                <div>
                  <v-btn color="red darken-4" class="white--text" x-small>
                    Eliminar
                  </v-btn>  
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <!--MSG-->
      <v-dialog
        v-model="dialogAdmin"
        persistent
        max-width="540"
      > 
        <v-card>
          <v-card-title v-if="optionAdd" class="text-h7">
            <v-icon color="blue-grey">mdi mdi-plus</v-icon> 
            <span class="dialog-alert blue-grey--text text--darken-2">Agregar</span>
          </v-card-title>
          <v-card-title v-if="optionEdit" class="text-h7">
            <v-icon color="blue-grey">mdi mdi-pencil</v-icon> 
            <span class="dialog-alert blue-grey--text text--darken-2">Edición</span>
          </v-card-title>
          <v-progress-linear
            v-show="pb_slide"
            indeterminate
            color="blue-grey"
          ></v-progress-linear>
          <v-card-text class="mt-4">
            <div> 
              <v-row>
                <v-col class="pb-0 pt-0" cols="12">
                  <v-alert
                    v-if="errors.id"
                    id="alert-fs"
                    class="pb-1 pt-1 pr-2 pl-2"
                    color="red darken-4"
                    outlined
                  >
                    <div>{{errors.id[0]}}</div>
                  </v-alert>
                  <v-text-field
                    v-model="titulo"
                    label="Titulo"
                    required
                  ></v-text-field>
                  <v-alert
                    v-if="errors.titulo"
                    id="alert-fs"
                    class="pb-1 pt-1 pr-2 pl-2"
                    color="red darken-4"
                    outlined
                  >
                    <div>{{errors.titulo[0]}}</div>
                  </v-alert>
                </v-col>
                <v-col class="pb-4 pt-0" cols="12" sm="6">
                  <v-text-field
                    v-model="relevancia"
                    label="Relevancia"
                    required
                  ></v-text-field>
                  <v-alert
                    v-if="errors.relevancia"
                    id="alert-fs"
                    class="pb-1 pt-1 pr-2 pl-2"
                    color="red darken-4"
                    outlined
                  >
                    <div>{{errors.relevancia[0]}}</div>
                  </v-alert>
                </v-col>
                <v-col class="pb-4 pt-0" cols="12" sm="6">
                  <v-select
                    v-model="estatus"
                    :items="status"
                    label="Estatus"
                    required
                  ></v-select>
                  <v-alert
                    v-if="errors.estatus"
                    id="alert-fs"
                    class="pb-1 pt-1 pr-2 pl-2"
                    color="red darken-4"
                    outlined
                  >
                    <div>{{errors.estatus[0]}}</div>
                  </v-alert>
                </v-col>
                <v-col class="pb-4 pt-2" cols="12">
                  <label>Imagen</label><br>
                  <input
                    class="pb-4"
                    type="file"
                    label="Imagen"
                    accept="image/*"
                    truncate-length="15"
                    @change="addImage"
                  />
                  <v-alert
                    v-if="errors.imagen"
                    id="alert-fs"
                    class="pb-1 pt-1 pr-2 pl-2"
                    color="red darken-4"
                    outlined
                  >
                    <div>{{errors.imagen[0]}}</div>
                  </v-alert>
                </v-col>
                <v-col class="pb-0 pt-2" cols="12">
                  <label>Video</label><br>
                  <input
                    class="pb-4"
                    type="file"
                    label="Video"
                    accept="video/*"
                    truncate-length="15"
                    @change="addVideo"
                    :disabled="fd"
                  />
                  <v-alert
                    v-if="errors.video"
                    id="alert-fs"
                    class="pb-1 pt-1 pr-2 pl-2"
                    color="red darken-4"
                    outlined
                  >
                    <div>{{errors.video[0]}}</div>
                  </v-alert>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="optionAdd"
              color="blue-grey darken-2"
              text
              @click="sendSlide(1)"
            >
              Agregar
            </v-btn>
            <v-btn
              v-if="optionEdit"
              color="blue-grey darken-2"
              text
              @click="sendSlide(2)"
            >
              Editar
            </v-btn>
            <v-btn
              color="blue-grey darken-2"
              text
              @click="closeSlide()"
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import firebase from 'firebase'
  export default {
    name: 'Admin',
    data(){
      return{
        id: "",
        titulo: "",
        relevancia: "",
        estatus: "",
        imagen: "",
        video: "",
        url_img: "",
        url_video: "",
        status: [
          {value: 1, text:"Activo"},
          {value: 0, text:"Inactivo"}
        ],
        errors: {
        },
        fd: true,
        dialogAdmin: false,
        pb_slide: false,
        optionAdd: false,
        optionEdit: false
      }
    },
    methods:{
      //RESET INFO
      resetInfo(){
        this.id = ""
        this.titulo = ""
        this.relevancia = ""
        this.estatus = ""
        this.imagen = ""
        this.video = ""
      },
      //RESET ERRORS
      resetErrors(){
        this.errors = {};
      },
      //ADD IMG
      addImage(event){
        this.imagen = event.target.files[0];
      },
      //ADD VIDEO
      addVideo(event){
        this.video = event.target.files[0];
      },
      openAddSlide(){
        this.resetErrors()
        this.optionAdd = true
        this.optionEdit = false
        this.fd = false
        this.dialogAdmin = true
      },
      openEditSlide(ind){
        this.resetErrors()
        this.optionAdd = false
        this.optionEdit = true
        this.id = this.slides[ind].id
        this.titulo = this.slides[ind].titulo
        this.relevancia = this.slides[ind].relevancia
        this.estatus = this.slides[ind].estado_id
        this.url_img = this.slides[ind].url_img
        //
        if(this.slides[ind].url_video=="NA"){
          this.fd = true
        }
        else{
          this.fd = false
        }
        //
        this.dialogAdmin = true
        console.log("EDIT")
      },
      closeSlide(){
        this.resetInfo()
        this.resetErrors()
        this.dialogAdmin = false
      },
      sendSlide(opt){
        this.pb_slide = true
        this.resetErrors()
        let url = ""
        let obForm = new FormData();
        obForm.append('id',this.id);
        obForm.append('titulo',this.titulo);
        obForm.append('relevancia',this.relevancia);
        obForm.append('estatus',this.estatus);
        obForm.append('imagen',this.imagen);
        obForm.append('video',this.video);
        //
        if(opt==1){
          url = process.env.VUE_APP_API_URL+"agregar_tutorial"
        }
        else if(opt==2){
          url = process.env.VUE_APP_API_URL+"editar_tutorial"
        }
        //
        axios
        .post(url, obForm)
        .then((res)=> {
          this.pb_slide = false
          if(res.data.estatus==1){

          }
          else if(res.data.estatus==0){
            this.errors = res.data.msg
          }
          else{

          }
        })
        .catch(error => {
          this.pb_slide = false
        })
      },
      deleteSlide(){

      }
    },
    computed: {
      ...mapState(['slides'])
    },
    created(){
      if(!firebase.auth().currentUser){
        this.$router.replace('login')
      }
    }
  }
</script>